/**
 * Complete starting themes, in the exact shape of the server's store.theme
 * (theme contract v2, see the server's docs/CONVENTIONS.md "Branding").
 *
 * A shop's theme records which preset it started from (`theme.preset`); any
 * token missing or invalid in the shop's theme is filled from that preset.
 * The values the shop saved always win.
 *
 * In development, `?preset=<id>` previews the storefront in another preset
 * (see devPreset.js). That override does not exist in production builds.
 */
export const PRESETS = {
  // Warm, calm skincare: cream paper, cocoa ink, one clay accent. A soft serif
  // for headings over an Indonesian-designed grotesque for reading.
  // Matches the server's default theme (and the Halimun demo's).
  'beauty-soft': {
    preset: 'beauty-soft',
    colors: {
      primary: '#3B2A24',
      primaryContrast: '#FBF7F2',
      accent: '#A65A40',
      accentContrast: '#FFFFFF',
      background: '#F8F3EE',
      surface: '#FFFFFF',
      surfaceAlt: '#EFE4D8',
      text: '#2B211D',
      muted: '#6F625A',
      border: '#E4D8CC',
      sale: '#A33B2B',
    },
    typography: {
      heading: 'fraunces',
      body: 'plus-jakarta-sans',
      headingWeight: 400,
      headingCase: 'normal',
      tracking: 'tight',
    },
    shape: { radius: 'md', button: 'pill' },
    layout: { hero: 'split', productCard: 'minimal' },
    announcement: {
      enabled: true,
      text: 'Pesanan yang masuk sebelum 14.00 WIB dikirim hari itu juga, Senin sampai Sabtu.',
    },
  },

  // The opposite end, for a streetwear or sneaker shop: paper white, hard
  // black, a safety-orange accent, square corners and an uppercase grotesk.
  'street-bold': {
    preset: 'street-bold',
    colors: {
      primary: '#111111',
      primaryContrast: '#FFFFFF',
      accent: '#FF5A1F',
      accentContrast: '#111111',
      background: '#FFFFFF',
      surface: '#F3F3F1',
      surfaceAlt: '#E6E6E1',
      text: '#111111',
      muted: '#555555',
      border: '#D4D4CF',
      sale: '#C8102E',
    },
    typography: {
      heading: 'archivo',
      body: 'space-grotesk',
      headingWeight: 700,
      headingCase: 'uppercase',
      tracking: 'tight',
    },
    shape: { radius: 'none', button: 'square' },
    layout: { hero: 'full-bleed', productCard: 'framed' },
    announcement: {
      enabled: true,
      text: 'Drop baru setiap Jumat pukul 19.00 WIB. Stok terbatas per ukuran.',
    },
  },
};

export const PRESET_IDS = Object.keys(PRESETS);
export const DEFAULT_PRESET_ID = 'beauty-soft';
